export const handleLocalStorage = {
  set(name: string, val: any) {
    if (typeof window === 'undefined') return;
    localStorage.setItem(name, JSON.stringify(val));
  },

  get(name: string) {
    if (typeof window === 'undefined') return null;

    const item = localStorage.getItem(name);

    if (!item) return null;

    return JSON.parse(item);
  },

  remove(name: string) {
    if (typeof window === 'undefined') return;

    localStorage.removeItem(name);
  },
};
